module.exports = __webpack_public_path__ + "static/media/05-d-calendar.8849c522.png";